/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CustomerconsultantsIdReassigncustomersPutRequest } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * CustomerconsultantsApi - axios parameter creator
 * @export
 */
export const CustomerconsultantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all customer consultants
         * @param {number} [exceptId] If ID should be not returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsGet: async (exceptId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customerconsultants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (exceptId !== undefined) {
                localVarQueryParameter['exceptId'] = exceptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific customer consultant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerconsultantsIdGet', 'id', id)
            const localVarPath = `/customerconsultants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific customer consultant
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdPut: async (id: number, person?: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerconsultantsIdPut', 'id', id)
            const localVarPath = `/customerconsultants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reassign customer relations on new consultant
         * @param {number} id 
         * @param {CustomerconsultantsIdReassigncustomersPutRequest} [customerconsultantsIdReassigncustomersPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdReassigncustomersPut: async (id: number, customerconsultantsIdReassigncustomersPutRequest?: CustomerconsultantsIdReassigncustomersPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerconsultantsIdReassigncustomersPut', 'id', id)
            const localVarPath = `/customerconsultants/{id}/reassigncustomers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerconsultantsIdReassigncustomersPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new customer consultant
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsPost: async (person?: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customerconsultants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerconsultantsApi - functional programming interface
 * @export
 */
export const CustomerconsultantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerconsultantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all customer consultants
         * @param {number} [exceptId] If ID should be not returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerconsultantsGet(exceptId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerconsultantsGet(exceptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific customer consultant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerconsultantsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerconsultantsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific customer consultant
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerconsultantsIdPut(id: number, person?: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerconsultantsIdPut(id, person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reassign customer relations on new consultant
         * @param {number} id 
         * @param {CustomerconsultantsIdReassigncustomersPutRequest} [customerconsultantsIdReassigncustomersPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerconsultantsIdReassigncustomersPut(id: number, customerconsultantsIdReassigncustomersPutRequest?: CustomerconsultantsIdReassigncustomersPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerconsultantsIdReassigncustomersPut(id, customerconsultantsIdReassigncustomersPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new customer consultant
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerconsultantsPost(person?: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerconsultantsPost(person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerconsultantsApi - factory interface
 * @export
 */
export const CustomerconsultantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerconsultantsApiFp(configuration)
    return {
        /**
         * Get all customer consultants
         * @param {number} [exceptId] If ID should be not returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsGet(exceptId?: number, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.customerconsultantsGet(exceptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific customer consultant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdGet(id: number, options?: any): AxiosPromise<Person> {
            return localVarFp.customerconsultantsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific customer consultant
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdPut(id: number, person?: Person, options?: any): AxiosPromise<Person> {
            return localVarFp.customerconsultantsIdPut(id, person, options).then((request) => request(axios, basePath));
        },
        /**
         * Reassign customer relations on new consultant
         * @param {number} id 
         * @param {CustomerconsultantsIdReassigncustomersPutRequest} [customerconsultantsIdReassigncustomersPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsIdReassigncustomersPut(id: number, customerconsultantsIdReassigncustomersPutRequest?: CustomerconsultantsIdReassigncustomersPutRequest, options?: any): AxiosPromise<void> {
            return localVarFp.customerconsultantsIdReassigncustomersPut(id, customerconsultantsIdReassigncustomersPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new customer consultant
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerconsultantsPost(person?: Person, options?: any): AxiosPromise<Person> {
            return localVarFp.customerconsultantsPost(person, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerconsultantsApi - object-oriented interface
 * @export
 * @class CustomerconsultantsApi
 * @extends {BaseAPI}
 */
export class CustomerconsultantsApi extends BaseAPI {
    /**
     * Get all customer consultants
     * @param {number} [exceptId] If ID should be not returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerconsultantsApi
     */
    public customerconsultantsGet(exceptId?: number, options?: AxiosRequestConfig) {
        return CustomerconsultantsApiFp(this.configuration).customerconsultantsGet(exceptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific customer consultant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerconsultantsApi
     */
    public customerconsultantsIdGet(id: number, options?: AxiosRequestConfig) {
        return CustomerconsultantsApiFp(this.configuration).customerconsultantsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific customer consultant
     * @param {number} id 
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerconsultantsApi
     */
    public customerconsultantsIdPut(id: number, person?: Person, options?: AxiosRequestConfig) {
        return CustomerconsultantsApiFp(this.configuration).customerconsultantsIdPut(id, person, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reassign customer relations on new consultant
     * @param {number} id 
     * @param {CustomerconsultantsIdReassigncustomersPutRequest} [customerconsultantsIdReassigncustomersPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerconsultantsApi
     */
    public customerconsultantsIdReassigncustomersPut(id: number, customerconsultantsIdReassigncustomersPutRequest?: CustomerconsultantsIdReassigncustomersPutRequest, options?: AxiosRequestConfig) {
        return CustomerconsultantsApiFp(this.configuration).customerconsultantsIdReassigncustomersPut(id, customerconsultantsIdReassigncustomersPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new customer consultant
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerconsultantsApi
     */
    public customerconsultantsPost(person?: Person, options?: AxiosRequestConfig) {
        return CustomerconsultantsApiFp(this.configuration).customerconsultantsPost(person, options).then((request) => request(this.axios, this.basePath));
    }
}
